/**
 * Neutral-host post-login page — the transient landing on app.systemdox.com.
 *
 * After login on the tenant-neutral host, this renders inside a TenantNeutralGate
 * that resolves the user's workspace and forwards to its root host
 * ({slug}.systemdox.com), where the real app (TenantShell + HubPage + the
 * console) lives. So this page is only ever a brief flash before the redirect —
 * it reuses the same HubPage body, wrapped in a minimal self-contained shell
 * (just the header) because there is no TenantShell on this host.
 *
 * It owns the TenantProvider/ProjectProvider the header + hub body need. On the
 * root host the identical HubPage is served by TenantShell instead, so the two
 * paths render the same hub.
 */

import { TenantProvider } from '@/contexts/TenantContext';
import { ProjectProvider } from '@/contexts/ProjectContext';
import { SystemDoxHeader } from '@/components/layout/SystemDoxHeader';
import HubPage from '@/pages/HubPage';

export default function LaunchPage() {
  return (
    <TenantProvider>
      {/* The header's project selector needs the provider; without it the
          fail-soft context would leave the launch header selector-less. */}
      <ProjectProvider>
        <div className="h-dvh bg-slate-50 dark:bg-slate-950 flex flex-col">
          {/* The one canonical SystemDox header — identical chrome to the root
              host's TenantShell. No search/notification providers on this host,
              so those zones stay hidden; the geometry is unchanged. */}
          <header className="sticky top-0 z-10 flex shrink-0 items-center border-b border-border bg-card px-4 py-3">
            <SystemDoxHeader />
          </header>

          <div className="flex flex-1 min-h-0 overflow-hidden">
            <HubPage />
          </div>
        </div>
      </ProjectProvider>
    </TenantProvider>
  );
}
